import PropTypes from "prop-types";
import { useMemo, useState } from "react";

const propTypes = {};

function BackgroundAnimated({ theme, animatedbackground }) {
  const [color, setColor] = useState("");

  useMemo(() => {
    if (animatedbackground) {
      switch (theme) {
        case "dark":
          setColor("bg-[length:400%_400%] bg-fixed bg-gradient-to-tl from-grey-800 via-grey-700 via-grey-700 to-grey-800");
          break;
        case "primary":
          setColor("bg-[length:400%_400%] bg-fixed bg-gradient-to-tl from-primary-800 via-primary-700 via-primary-900 to-primary-800");
          break;
        default:
          break;
      }
    } else {
      switch (theme) {
        case "dark":
          setColor("bg-grey-800");
          break;
        case "primary":
          setColor("bg-primary-800");
          break;
        default:
          break;
      }
    }
  }, [theme]);

  return (
    <div className={`${color} waves absolute h-full w-full z-[-2] m-auto overflow-hidden`}>
      <div className="wave bg-primary-25/25 absolute w-[200%] rounded-tl-[1000%] rounded-tr-[1000%] h-56 bottom-0 left-0 opacity-80"></div>
      <div className="wave bg-primary-25/25 absolute w-[200%] rounded-tl-[1000%] rounded-tr-[1000%] h-48 bottom-0 left-0 opacity-80"></div>
      <div className="wave bg-primary-25/25 absolute w-[200%] rounded-tl-[1000%] rounded-tr-[1000%] h-36 bottom-0 left-0 opacity-90"></div>
    </div>
  );
}

BackgroundAnimated.propTypes = propTypes;
export default BackgroundAnimated;
